import { shaderMaterial } from "@react-three/drei";
import { Vector3, Vector4, type Texture } from "three";
import fragmentShader from "./particles.frag";
import vertexShader from "./particles.vert";

export const ParticlesMaterial = shaderMaterial(
  {
    uTime: 0,

    // Main texture used by particles
    uTexture: null as Texture | null,
    uTextureSize: [0, 0] as [number, number],
    uColorDead: new Vector4(0, 0, 0, 0),

    // Use a texture for particle color over lifetime
    uColors: null as Texture | null,
    uColorsCount: 0,
    uColorStops: null as Texture | null,
    uColorStopCount: 0,

    // Use a texture for particle's size over its lifetime
    uSizes: null as Texture | null,
    uSizesCount: 0,
    uSizeStops: null as Texture | null,
    uSizeStopCount: 0,

    // Properties to enable sprite sheet animation
    uIsAnimationSheetEnabled: false,
    uStartSpriteCellId: 0,
    uEndSpriteCellId: 0,
    uSpriteCellChangeSpeed: 0,
    uSpriteCellWidth: 0,
    uSpriteCellHeight: 0,
    uSpriteRandomStartCell: false as boolean,
    uSpriteCellLoop: false as boolean,

    // Textures used by particles with custom shaders
    diffuseSampler: null as Texture | null,
    maskTexture: null as Texture | null,

    // Other particle properties
    uIsLocal: false as boolean, // defines if particles should follow emitter through space
    uStopEmitTime: -1, // stop emitting particles after this duration. <= 0 means never
    uAcceleration: new Vector3(0, 0, 0), // acceleration applied to particles (e.g. gravity)
  },
  vertexShader,
  fragmentShader,
);
